import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['dropdown', 'input', 'username']

  increaseHeight(event){
    let element = event.currentTarget
    element.dataset.action = ''
    element.rows = 5
  }

  showUsersDropdown(event){
    let list = document.getElementById('user-list')
    list.innerHTML = ' '
    this.dropdownTarget.classList.remove('hidden')
    let url = `/users/username?term=${event.currentTarget.value}`
    fetch(url, { headers: { accept: "application/json" } })
      .then(response => response.json())
      .then((data) => {
        data.forEach(element => {
          let node = document.createElement('a')
          node.className = "text-gray-700 block px-4 py-2 text-sm result"
          node.innerText = element.label
          node.href = ""
          node.dataset.user = element.id
          node.dataset.action = 'click->form#selectUser'
          list.appendChild(node)
        });
    });
  }

  selectUser(event){
    event.preventDefault()
    this.dropdownTarget.classList.add('hidden')
    let user = event.currentTarget.dataset.user
    this.inputTarget.value = user
    this.usernameTarget.value = event.currentTarget.innerText
  }

  submitForm(event){
    let form = document.getElementById(event.currentTarget.dataset.form)
    form.submit()
  }

  // Locale toggle for AdminUser#Edit
  toggleLocales(event){
    let elementToToggle = document.getElementById(event.currentTarget.dataset.elementId)
    let translatorCheckbox = document.getElementById('translator-checkbox')
    let reviewerCheckbox = document.getElementById('reviewer-checkbox')

    let classList = elementToToggle.classList

    if(translatorCheckbox.checked || reviewerCheckbox.checked ) {

      if(classList.contains('hidden')) classList.remove('hidden')

    } else {
      elementToToggle.classList.add('hidden')
    }
  }

  // Clear defined input if this function is called
  clearInput(event) {
    let elementToClear = document.getElementById(event.currentTarget.dataset.clearId)
    elementToClear.value = ''
  }

  clearAfterSubmit(event){
    let elements = document.getElementsByClassName(event.currentTarget.dataset.inputClasses)
    Array.from(elements).forEach( element => {
      element.value = ''
    } )
  }

  addToForm(event){
    let checkboxes = document.querySelectorAll("input[type=checkbox]:checked")
    let elements = document.querySelectorAll(`.${event.currentTarget.dataset.elements}`)

    elements.forEach(element => {
      element.value = Array.from(checkboxes).map(e => e.id)
    })
  }

  toggleCheckboxes(event){
    let checkboxClass = event.currentTarget.dataset.checkboxClass
    let elements = document.querySelectorAll(`.${checkboxClass}`)
    elements.forEach((el) => {
      el.checked = !el.checked;
  });
  }
}
